<template>
  <div class="loading-component">
    <div class="loading-item loading-item-1"></div>
    <div class="loading-item loading-item-2"></div>
    <div class="loading-item loading-item-3"></div>
    <div class="loading-item loading-item-4"></div>
  </div>
</template>

<script>
  export default {
    name: 'Loading',
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .loading-component {
    width: @loading-size;
    height: @loading-size;
    margin: 0 auto;
    animation: loadingWarp 4s infinite ease;
    animation-delay: -1s;
  }

  .loading-item {
    width: @loading-item-size;
    height: @loading-item-size;
    border-radius: @border-radius-round;
  }

  .loading-item-1 {
    float: left;
    margin-bottom: @loading-space;
    background-color: @loading-color-1;
    animation: loading1 1s infinite ease;
  }

  .loading-item-2 {
    float: right;
    margin-bottom: @loading-space;
    background-color: @loading-color-2;
    animation: loading2 1s infinite ease;
  }

  .loading-item-3 {
    float: left;
    background-color: @loading-color-3;
    animation: loading3 1s infinite ease;
  }

  .loading-item-4 {
    float: right;
    background-color: @loading-color-4;
    animation: loading4 1s infinite ease;
  }

  @keyframes loadingWarp {
    25% {
      transform: rotate(90deg);
    }
    50% {
      transform: rotate(180deg);
    }
    75% {
      transform: rotate(270deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  @keyframes loading1 {
    50% {
      transform: translateX(@loading-animate-space) translateY(@loading-animate-space);
    }
    100% {
      transform: translateX(0) translateY(0);
    }
  }

  @keyframes loading2 {
    50% {
      transform: translateX(-@loading-animate-space) translateY(@loading-animate-space);
    }
    100% {
      transform: translateX(0) translateY(0);
    }
  }

  @keyframes loading3 {
    50% {
      transform: translateX(@loading-animate-space) translateY(-@loading-animate-space);
    }
    100% {
      transform: translateX(0) translateY(0);
    }
  }

  @keyframes loading4 {
    50% {
      transform: translateX(-@loading-animate-space) translateY(-@loading-animate-space);
    }

    100% {
      transform: translateX(0) translateY(0);
    }
  }
</style>
